import {
  BLACK,
  DARK_GREY,
  DEEP_BLUE,
  DIVIDER,
  GREY,
  SCOUT_TEAL,
  WHITE
} from '../../../ThemeContext/constants';
import { theme } from '../../../ThemeContext/ThemeObject';
import { actionsModalReducedPaddingCommonStyles } from '../../shared/commonStyles';
import {
  actionButton,
  actionModalFormLine,
  closeIcon,
  modalCreateButton,
  noQuestionsText,
  subPageHeader
} from '../../shared/styleClasses';


export const classes = {
  questionsPageContainer: {
    paddingTop: '6px',
    overflowY: 'visible',
    width: '100%'
  },
  pageHeader: subPageHeader,
  modalWrapper: {
    height: '100%',
    position: 'relative',
    display: 'contents'
  },
  questionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '24px',
    rowGap: '28px',
    width: '100%',
    position: 'relative',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  questionsHeader: {
    display: 'flex',
    paddingRight: '18px',
    textAlign: 'center',
    position: 'sticky',
    top: '0px',
    height: 'auto',
    zIndex: 2,
    backgroundColor: WHITE,
    padding: '20px'
  },
  noQuestionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  noQuestionsText,
  actionsContianer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '22px',
    margin: '30px 0 48px 0',
    padding: '0px 16px'
  },
  actionButton,
  actionsModalReducedPadding: {
    ...actionsModalReducedPaddingCommonStyles,
    paddingBottom: 0
  },
  closeIcon,
  actionModalHeader: {
    fontFamily: 'Source Sans Pro',
    fontSize: '28px',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginLeft: '15px'
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    margin: '24px 0 0 0'
  },
  modalFormLine: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    columnGap: '50px',
    rowGap: '26px',
    alignItems: 'center',
    marginBottom: '20px',
    width: '100%'
  },
  actionModalFormLine,
  modalFooter: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'flex-end',
    columnGap: '20px',
    marginTop: 'auto',
    marginBottom: '40px'
  },
  modalFooterSmallerSection: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'flex-end',
    columnGap: '20px',
    marginBottom: '40px'
  },
  modalCancelButton: {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    fontWeight: 'bold',
    width: '100px',
    textTransform: 'none',
    textDecoration: 'underline',
    color: theme.palette.error.main,
    backgroundColor: WHITE,
    borderRadius: '6px',
    boxShadow: 'none',
    padding: '5px 0px',
    '&:hover': {
      backgroundColor: WHITE,
      textDecoration: 'none',
      boxShadow: 'none'
    }
  },
  modalCreateButton,
  formError: {
    color: theme.palette.error.main,
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: '13px',
    position: 'absolute',
    top: '-24px',
    left: '4px'
  },
  inlineError: {
    color: theme.palette.error.main,
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: '13px',
    left: '4px'
  },
  checkboxContainer: {
    display: 'flex',
    marginLeft: '19px',
    flexWrap: 'wrap'
  },
  switchLabels: {
    justifyContent: 'start',
    width: 'min-content',

    '& .MuiFormControlLabel-label': {
      fontFamily: 'Source Sans Pro',
      fontSize: '14px',
      color: theme.palette.common.black,
      width: 'max-content'
    },
    '& .MuiSwitch-track': {
      backgroundColor: 'rgba(0,0,0,0.38)',
      opacity: '1'
    },
    '& .Mui-checked+.MuiSwitch-track': {
      backgroundColor: 'rgb(91, 196, 191, 0.17) !important',
      opacity: '1 !important'
    },
    '& .Mui-checked': {
      color: 'rgb(91, 196, 191, 0.5) !important'
    }
  },
  switch: {
    '& .MuiSwitch-thumb': {
      color: WHITE
    },
    '& .Mui-disabled': {
      color: '#BBBBBB !important',
      '& .Mui-checked+.MuiSwitch-track': {
        backgroundColor: `${DIVIDER} !important`,
        opacity: '1 !important'
      },
      '& .MuiSwitch-thumb': {
        color: '#BBBBBB !important'
      },
      '& .MuiSwitch-track': {
        color: '#BBBBBB !important',
        '& :hover': {
          backgroundColor: '#BBBBBB !important'
        }
      },
      '& :hover': {
        backgroundColor: '#BBBBBB !important'
      }
    },
    '& :hover': {
      '& .MuiSwitch-track': {
        backgroundColor: `${BLACK} !important`
      }
    }
  },
  switchActive: {
    '& .Mui-checked+.MuiSwitch-track': {
      backgroundColor: 'rgb(91, 196, 191, 0.17) !important',
      opacity: '1 !important'
    },
    '& .MuiSwitch-thumb': {
      color: SCOUT_TEAL
    },
    '& .Mui-disabled': {
      color: '#BBBBBB !important',
      '& .Mui-checked+.MuiSwitch-track': {
        backgroundColor: `${DIVIDER} !important`,
        opacity: '1 !important'
      },
      '& .MuiSwitch-thumb': {
        color: '#BBBBBB !important'
      },
      '& .MuiSwitch-track': {
        color: '#BBBBBB !important',
        '& :hover': {
          backgroundColor: '#BBBBBB !important'
        }
      },
      '& :hover': {
        backgroundColor: '#BBBBBB !important'
      }
    }
  },
  labelActive: {
    '& .MuiFormControlLabel-label': {
      color: '#CCCCCC',
      fontFamily: 'Source Sans Pro',
      fontSize: '14px',
      width: 'max-content'
    }
  },
  addChoiceContainer: {
    padding: '20px 15px'
  },
  addChoiceHead: {
    display: 'flex',
    alignItems: 'baseline'
  },
  addChoiceLabel: {
    color: '#838383',
    paddingLeft: '4px'
  },
  modalAddChoiceButton: {
    fontFamily: 'Source Sans Pro',
    fontSize: '12px',
    fontWeight: 'bold',
    textTransform: 'none',
    color: SCOUT_TEAL,
    backgroundColor: `${SCOUT_TEAL}12`,
    borderRadius: '6px',
    boxShadow: 'none',
    marginTop: '10px',
    marginLeft: '20px',
    '&:hover': {
      backgroundColor: '#4da8a412',
      boxShadow: 'none'
    }
  },
  choice: {
    marginTop: '15px',
    display: 'flex',
    alignItems: 'center'
  },
  availabilityContainer: {
    padding: '20px 15px'
  },
  config: {
    marginTop: '15px',
    display: 'flex',
    flexDirection: 'column'
  },
  questionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: 2,
    background: '#F3F3F3',
    borderRadius: '6px',
    minWidth: 'fit-content'
  },
  questionInput: {
    '& span': {
      fontSize: '14px !Important'
    }
  },
  questionsTitle: {
    color: theme.palette.primary.main,
    fontSize: '13px',
    fontWeight: 'bold',
    paddingBottom: '5px',
    width: '70px',
    padding: '0 6px'
  },
  iconGreen: {
    color: theme.palette.success.main,
    fontSize: '1.25rem',
    margin: 'auto',
    display: 'flex'
  },
  iconRed: {
    color: theme.palette.error.main,
    fontSize: '1.25rem',
    margin: 'auto',
    display: 'flex'
  },
  weightValue: {
    fontSize: '13px',
    textAlign: 'center'
  },
  noticeContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '9px 16px',
    border: `1px solid ${theme.palette.action.main}`,
    borderRadius: '8px',
    color: DARK_GREY,
    fontSize: '16px',
    margin: '16px',
    rowGap: '1px'
  },
  noticeIcon: {
    color: theme.palette.error.main,
    marginTop: '4px',
    fontSize: '16px'
  },
  infoIcon: {
    color: theme.palette.action.main,
    marginTop: '4px',
    fontSize: '16px'
  },
  dragHandle: {
    color: GREY,
    fontSize: 30,
    padding: '6px',
    marginRight: '10px',
    '&:hover': {
      borderRadius: '8px',
      backgroundColor: DIVIDER
    },
    outline: 'none'
  },
  sortableItemSwitchContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 6px',
    marginBlock: 'auto',
    minWidth: '100px'
  },
  switchLabel: {
    marginTop: theme.spacing(0.5),
    fontSize: theme.spacing(1.5)
  },
  toggleButtonsContainer: {
    marginTop: '40px',
    marginBottom: '40px',
    padding: '0px 16px'
  },
  aiSwitch: {
    width: 'unset',
    '& .MuiSwitch-thumb': {
      backgroundColor: `${DEEP_BLUE} !important`
    },
    '& .MuiSwitch-track': {
      backgroundColor: 'rgba(0,0,0,0.38)',
      opacity: '1'
    },
    '& .Mui-checked+.MuiSwitch-track': {
      backgroundColor: '#92ADF4 !important',
      opacity: '1 !important'
    }
  },
  actionButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginRight: '-8px'
  },
  modalStyleOverrides: {
    height: 'auto',
    maxHeight: '84vh',
    width: '900px',
    padding: '40px'
  },
  modalContainer: {
    width: '100%',
    height: '100%',
    rowGap: 3,
    overflow: 'auto'
  },
  questionLibraryModalListHeader: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    paddingTop: 1
  },
  questionLibraryModalEmptyStateContainer: {
    alignItems: 'center',
    rowGap: 3,
    justifyContent: 'center',
    height: '75%'
  },
  questionLibraryModalEmptyStateMessage: {
    color: theme.palette.common.grey,
    fontWeight: 'bold',
    fontSize: '20px'
  }
};
